import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  storeSignedId(event) {
    const { target, detail } = event

    const originalName = target.getAttribute("name")
    if (!detail?.signed_id || !originalName) {
      console.warn("No signed_id or name found on upload target")
      return
    }

    // Remove name from file input
    target.removeAttribute("name")

    // Add hidden input with real signed_id
    const hiddenInput = document.createElement("input")
    hiddenInput.type = "hidden"
    hiddenInput.name = originalName
    hiddenInput.value = detail.signed_id

    this.element.appendChild(hiddenInput)
  }
}











